import {
  Grid,
  Paper,
  PaperGroupItem,
  Skeleton
} from '@focaldata/cin-ui-components'
import React from 'react'
import useStyles from './styles'

const BasicQuestionChartCardLoading: React.FC = () => {
  const { classes } = useStyles()
  return (
    <Grid item className={classes.root}>
      <Paper>
        <PaperGroupItem>
          {' '}
          <Grid container direction="row" justifyContent="space-between">
            <div className={classes.titleContainer}>
              <Grid container direction="column">
                <Grid item container direction="row">
                  <Skeleton height={30} width={80} />
                </Grid>
                <Grid item>
                  <Skeleton height={40} width={160} />
                </Grid>
              </Grid>
            </div>
          </Grid>
        </PaperGroupItem>
        <PaperGroupItem>
          <Grid container direction="column">
            <Skeleton height={40} width={430} />
            <Skeleton height={40} width={300} />
            <Skeleton height={40} width={245} />
            <Skeleton height={40} width={160} />
            <Skeleton height={40} width={150} />
          </Grid>
        </PaperGroupItem>
      </Paper>
    </Grid>
  )
}

export default BasicQuestionChartCardLoading
